import { MDSBrandText, ValidationProps } from '@midwest/web/base';
import styled from 'styled-components';

export const HelperText = styled(MDSBrandText.BodyRegular150)<ValidationProps>`
  color: ${(p) =>
    p.$disabled
      ? p.theme.midwestColors.textDisabled
      : p.theme.midwestColors.neutralDarkStrong};
`;

export const HelperTextShift = styled(MDSBrandText.BodyRegular200)`
  color: ${(p) => p.theme.midwestColors.componentFormColorTextLabelDefault};
`;
